import React from "react";
import { CLOTHING_SIZES } from "@/lib/sharing-tree-clothing";

export default function SharingTreeClothingSizes({ member, onChange }) {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 mt-3">
      {[["pant_size", "Pant Size"], ["shirt_size", "Shirt Size"], ["pj_size", "PJ Size"]].map(([key, label]) => {
        const value = member[key] || "";
        return (
          <label key={key} className="block min-w-0 text-xs font-semibold">
            <span className="block mb-1">{label}</span>
            <select value={value} onChange={(e) => onChange({ [key]: e.target.value })}
              className="w-full min-w-0 px-3 py-2 rounded-lg border bg-white text-sm font-normal"
              style={{ borderColor: "var(--fb-border)" }}>
              <option value="">— Select —</option>
              {value && !CLOTHING_SIZES.includes(value) && <option value={value}>{value}</option>}
              {CLOTHING_SIZES.map((size) => <option key={size} value={size}>{size}</option>)}
            </select>
          </label>
        );
      })}
    </div>
  );
}
